module.exports = __webpack_public_path__ + "static/media/offer-accepted-image@1x.c731b671.png";